export const FETCH_CONNECTOR_ACTIVITY = 'FETCH_CONNECTOR_ACTIVITY'
export const FETCH_CONNECTOR_ACTIVITY_SUCCESS = `${FETCH_CONNECTOR_ACTIVITY}_SUCCESS`

export const FETCH_ACTIVE_NOW = 'FETCH_ACTIVE_NOW'
export const FETCH_ACTIVE_NOW_SUCCESS = `${FETCH_ACTIVE_NOW}_SUCCESS`

export const FETCH_CHAT_ACTIVITY = 'FETCH_CHAT_ACTIVITY'
export const FETCH_CHAT_ACTIVITY_SUCCESS = `${FETCH_CHAT_ACTIVITY}_SUCCESS`

export const FETCH_SYSTEM_CONNECTOR_ACTIVITY = 'FETCH_SYSTEM_CONNECTOR_ACTIVITY'
export const FETCH_SYSTEM_CONNECTOR_ACTIVITY_SUCCESS = `${FETCH_SYSTEM_CONNECTOR_ACTIVITY}_SUCCESS`

export const FETCH_SPACE_ENGAGEMENT_ANALYTICS = 'FETCH_SPACE_ENGAGEMENT_ANALYTICS'
export const FETCH_SPACE_ENGAGEMENT_ANALYTICS_SUCCESS = `${FETCH_SPACE_ENGAGEMENT_ANALYTICS}_SUCCESS`
